module.exports = __webpack_public_path__ + "img/4.2.1c2ad15b.png";